import { render, staticRenderFns } from "./FormOrdemServico.vue?vue&type=template&id=1cc74781&scoped=true"
import script from "./FormOrdemServico.vue?vue&type=script&setup=true&lang=js"
export * from "./FormOrdemServico.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc74781",
  null
  
)

export default component.exports